import type { AppComboBoxProps } from "@1js/acui-combobox";

import type { AppControlProps } from "../../controls/AppControlProps";
import type { RibbonControlProps } from "../Controls/RibbonControlProps";

export function hasPinnedCombobox(
  topLevelControls: AppControlProps[] | RibbonControlProps[],
  index: number
) {
  if (
    topLevelControls.length > index + 1 &&
    topLevelControls[index + 1].type === "AppComboBoxProps"
  ) {
    const comboBox: AppComboBoxProps = topLevelControls[
      index + 1
    ] as AppComboBoxProps;
    return { hasPinnedControl: comboBox.pinToPreviousComboBox };
  }
  return {};
}
